import { render, staticRenderFns } from "./WidgetsReportPaymentVoucher.vue?vue&type=template&id=6ae53230&scoped=true"
import script from "./WidgetsReportPaymentVoucher.vue?vue&type=script&lang=js"
export * from "./WidgetsReportPaymentVoucher.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportPaymentVoucher.vue?vue&type=style&index=0&id=6ae53230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae53230",
  null
  
)

export default component.exports